<template>
  <div class="orders-list" ref='list'>
    <!-- <div v-if='orders' class="orders-list__title">
      これから作業する案件を選んでください
    </div> -->
    <div v-show='showServiceList' v-if='services' class="dropdown__list">
      <button v-for='service in services' :key='service.id'
              @click='updateService(service)'
              :class='curServiceName == service.name ? "selected":""'>
        {{ service.name }}
      </button>
    </div>
    <div class="orders-list__search_area">
      <div class="orders-list__filter">
        <div class="dropdown">
          <div class="dropdown__title" @click='showServiceList=true'
               v-if='curServiceName'>
            {{ curServiceName }} &#9660;
          </div>
        </div>
      </div>
      <div class="orders-list__search_word">
        <input type="text" v-model="search_word" placeholder="絞り込み" @blur="refresh" @keydown.enter="searchWord">
        <div class="info">* お客様名、電話番号、オーダーID、住所の一部をご入力ください。</div>
      </div>
    </div>
    <div class="backdrop"
         v-show='showServiceList || showTypeList'
         @click='showServiceList=false;showTypeList=false '>
    </div>

    <p class='empty' v-if='nullResult'>現在確認できる案件はありません。</p>
    <ul>
      <li v-for='(order, index) in orders' :key='index'>
        <router-link class="orders-list__item"
                     :to='{name: "orderDesc", params: {id: order.order_id}}'>
          <Item :order='order'/>
        </router-link>
      </li>
    </ul>

    <div class='orders-list__more'
         v-if='orders && orders.length < total'>
      <button class="btn" @click="nextTapped" :disabled="validNextButton">更に読込</button>
    </div>
  </div>
</template>

<script>
import Item from './Item'
import Morescroll from '@/lib/morescroll'

var scrollController = null;

export default {
  name: "OrderList",
  data: function () {
    return {
      orders: [],
      total: 1,
      loadCount: 0,
      loading: false,

      services: null,
      curService: localStorage.getItem('current_service_id'),

      showServiceList: false,
      showTypeList: false,
      search_word: '',
    }
  },
  computed: {
    curServiceName: function () {
      if (this.services == null) return '';
      let service = this.services.find(service => service.id == this.curService)
      if (service == null) return '';
      return service.name;
    },
    nullResult: function () {
      return this.loadCount > 0 && this.orders.length == 0;
    },
    validNextButton: function () {
      return this.loading;
    }
  },
  methods: {
    load: function () {
      if (this.total <= this.orders.length) return false;
      this.loading = true;
      this.$api
          .getOrders(this.loadCount + 1, this.curService, this.search_word)
          .then((res) => {
            this.loading = false;
            this.orders = this.orders.concat(res.data.data.results.orders);
            this.total = res.data.data.pagination.total;
            this.services = res.data.data.results.services;
            this.curService = res.data.data.results.current_service_id;

            this.loadCount++;
          })
    },
    updateService: function (service) {
      this.curService = service.id;
      this.showServiceList = false;
      this.loadCount = 0;
      this.refresh();
    },
    searchWord: function (event) {
      if (event.keyCode !== 13) return;
      event.target.blur();
    },
    refresh: function () {
      this.orders = [];
      this.total = 1;
      this.loadCount = 0;
      this.load();
    },
    nextTapped: function () {
      this.load();
    }
  },
  components: {Item},
  mounted: function () {
    this.$$.context({
      title: '作業一覧',
      previous: '',
      showAccountControl: 'true'
    });

    scrollController = new Morescroll({
      el: this.$refs.list,
      onOverScroll: () => {
        this.refresh();
      },
      onScrollBottom: () => {
        this.load();
      }
    });
    this.load();
  },
  beforeDestroy: function () {
    scrollController.destroy();
    if (this.curService) {
      localStorage.setItem('current_service_id', this.curService);
    }
  }
}
</script>

<style lang='scss'>
@keyframes showup {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.orders-list {
  .empty {
    text-align: center;
  }

  .backdrop {
    animation: showup .2s;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 9;
  }

  &__filter {
    display: flex;
    justify-content: space-between;
  }

  .dropdown {
    margin-top: -.5em;
    margin-bottom: 0;
    display: flex;
    justify-content: center;

    &__title {
      color: #3366ff;
      font-weight: bold;
      padding: 15px 10px 5px 10px;
      user-select: none;
    }

    &__list {
      animation: showup .2s;
      user-select: none;
      text-align: left;
      position: fixed;
      top: 200px;
      left: 50%;
      transform: translateX(-50%);
      background: #fff;
      padding: .5em 0;
      min-width: 240px;
      border-radius: 2px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .3);
      z-index: 99;
      max-height: 360px;
      overflow: auto;

      button {
        padding: .75em 1.5em;
        display: block;
        width: 100%;
        text-align: left;
        font-size: 1em;
        border-bottom: 1px solid #ddd;
        color: #3366ff;

        &.selected {
          background: #3366ff;
          color: #fff;
        }

        &:last-child {
          border: none;
        }

        .icon {
          font-size: 1.2em;
          margin-right: .5em;

          & path {
            fill: #3366ff;
          }
        }
      }
    }
  }

  ul {
    user-select: none;
    list-style: none;
    display: block;
    position: relative;
    top: 100px;

    li {
      display: block;
    }
  }

  padding: 10px 8px 4em;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  &__title {
    text-align: center;
    margin-bottom: 16px;
    font-size: 18px;
    line-height: 1.5;
  }

  &__item {
    display: block;
    text-decoration: none;
    color: inherit;
    border-bottom: 1px solid #ddd;
    transition: background .2s ease;

    &:hover {
      background: rgba(0, 0, 0, .05);
    }
  }

  &__more {
    text-align: center;

    &:before {
      content: '...';
      font-size: 28px;
      font-weight: bold;
      color: #aaa;
    }

    button {
      display: block;
      margin: auto;
      font-size: small;
    }
  }

  &__search_area {
    position: absolute;
    top: 56px;
    left: 0px;
    right: 0px;
    height: 100px;
    z-index: 8;
    background-color: #ffe;
    border-bottom: #990 solid 1px;
  }

  &__search_word {
    padding: 0px 20px;

    input {
      height: 30px;
      font-size: 12px;
      border: #3366ff solid 1px;
      border-radius: 8px;
    }

    .info {
      font-size: 12px;
    }

    @media all and (max-width: 420px) {
      input {
        font-size: 10px;
      }
      .info {
        font-size: 10px;
        line-height: 0.9rem;
      }
    }
  }
}
</style>